import { render, staticRenderFns } from "./ToolsList.vue?vue&type=template&id=59c4d475&scoped=true"
import script from "./ToolsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToolsList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ToolsList.vue?vue&type=style&index=0&id=59c4d475&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c4d475",
  null
  
)

export default component.exports